export default {
  heading: 'Kalam, cursive',
  body: 'Commissioner, sans-serif',
  monospace: 'Menlo, monospace',
  display: 'Kalam, cursive',
  googleFonts: ['Yantramanav', 'Commissioner', 'Kalam']
  // customFamilies: [''],
  // customUrls: [''],
}
